import React, { Component } from "react";
import { connect } from "react-redux";

import { Navigate } from "react-router-dom";
import _ from "lodash";

import {
  fetchPurchaseOrderDetail,
  fetchPurchaseOrderDetailSuccess,
  fetchPurchaseOrderDetailFailure,
  createPurchaseOrderItemLabelSuccess,
  deletePurchaseOrderItemLabelSuccess,
} from "../../store/purchaseOrders/actions";

import {
  associatePurchaseOrderInvoice,
  updateItemInPurchaseOrder,
  finishPurchaseOrder,
  changePurchaseOrderInvoiceNumber,
  changePurchaseOrderInvoiceAmount,
  createPurchaseOrderItemLabel,
  deletePurchaseOrderItemLabel,
} from "../../store/purchaseOrders/api";

import { purchaseOrderStatusOptions, purchaseOrderTransportConditions } from "../../utils/Helpers";
import Alert from "../../utils/Alert";
import Modal from "../../components/generics/Modal";

import Spinner from "../../components/generics/Spinner";
import PurchaseOrderDetail from "../../components/purchaseOrders/PurchaseOrderDetail";
import PurchaseOrderDetailHeader from "../../components/purchaseOrders/PurchaseOrderDetailHeader";
import PurchaseOrderCreateLabelHeader from "../../components/purchaseOrders/PurchaseOrderCreateLabelHeader";
import PurchaseOrderCreateLabelAdd from "../../components/purchaseOrders/PurchaseOrderCreateLabelAdd";
import PurchaseOrderPrint from "../../components/purchaseOrders/PurchaseOrderPrint";
import PurchaseOrderCreateLabelListAdded from "../../components/purchaseOrders/PurchaseOrderCreateLabelListAdded";
import { withRouter } from "utils/WithRouter";

export class PurchaseOrderInvoiceDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invoice: undefined,
      error: false,
      transportCondition: "good",
      submitting: false,
      transportTemperature: "",
      errorTemperature: false,
      newInvoice: undefined,
      isInvoiceUpdating: false,
      invoiceError: false,
      newAmount: undefined,
      isAmountUpdating: false,
      amountError: false,
      openAmountMismatchModal: false,
      openPricesChangedModal: false,
      finishErrors: [],
      creatingLabelsForItem: null,
      scanLabels: false,
      labelError: undefined,
      successMessage: undefined,
    };

    this.alertRef = React.createRef();
    this.debounceHandleFinishPurchaseOrder = _.debounce(this.handleFinishPurchaseOrder, 300);
    this.debounceConfirmSubmit = _.debounce(this.confirmSubmit, 300);
  }
  componentDidMount() {
    this.props.fetchPurchaseOrderDetail(this.props.match.params.id);
  }

  handleAssociateInvoice = () => {
    const purchaseOrderId = this.props.match.params.id;
    const invoiceId = this.state.invoice;
    if (invoiceId)
      associatePurchaseOrderInvoice(purchaseOrderId, { invoice: invoiceId })
        .then((response) => {
          this.alertRef.current.sendAlert(
            `Invoice #${invoiceId} associated successfully with Purchase Order #${purchaseOrderId}`,
            "success"
          );
          //Refresh Purchase Order
          this.props.fetchPurchaseOrderDetail(this.props.match.params.id);
        })
        .catch((error) => {
          const message =
            error && error.response && error.response.data
              ? `Can't associate Invoice #${invoiceId} with Purchase Order #${purchaseOrderId}. ${error.response.data}`
              : `Can't associate Invoice #${invoiceId} with Purchase Order #${purchaseOrderId}.`;
          this.alertRef.current.sendAlert(message);
          this.setState({ error: true });
        });
    else {
      this.setState({ error: true });
    }
  };

  handleInvoiceInput = (event) => {
    this.setState({ invoice: event.target.value, error: false });
  };

  handleTemperatureSubmit = (item, newTemperature) => {
    let inventories = this.props.purchaseOrder.purchaseOrder.items;
    const item_index = _.findIndex(inventories, function (o) {
      return o.id === item.id;
    });

    newTemperature = parseFloat(newTemperature) || null;
    if (inventories[item_index] && inventories[item_index].temperature !== newTemperature) {
      updateItemInPurchaseOrder(item.id, { temperature: newTemperature }).then(
        (response) => {
          this.alertRef.current.sendAlert(`${item.name} temperature has been updated!`, "success");
        },
        () => {
          this.alertRef.current.sendAlert(`${item.name} temperature could not be updated`);
        }
      );
    }
  };

  handleFinishPurchaseOrder = () => {
    const purchaseOrder = this.props.purchaseOrder.purchaseOrder;
    if (!purchaseOrder.invoice) this.alertRef.current.sendAlert("Only purchase order associated with an Invoice can be finished.");
    else {
      const errorTemperature = !this.state.transportTemperature;
      this.setState({ errorTemperature });
      if (!errorTemperature && !this.state.submitting) {
        this.finishPurchaseOrder();
      }
    }
  };

  finishPurchaseOrder = (checkAmountMatchAndPricesChanged = true) => {
    this.setState({ submitting: true });
    const po_id = this.props.purchaseOrder.purchaseOrder.id;
    let data = {
      transport_condition: this.state.transportCondition,
      transport_temperature: this.state.transportTemperature,
      purchase_order_items: {},
      check_amount_match_and_prices_changed: checkAmountMatchAndPricesChanged,
    };
    finishPurchaseOrder(po_id, data)
      .then(() => {
        // Refresh Purchase Order
        this.props.fetchPurchaseOrderDetail(po_id);
        this.alertRef.current.sendAlert("Your purchase order has been successfully finished", "success");
        this.setState({ submitting: false });
      })
      .catch((err) => {
        if (err.response.status === 400 && ("missMatchAmount" in err.response.data || "pricesChanged" in err.response.data)) {
          this.setState({ openAmountMismatchModal: true, finishErrors: err.response.data });
        } else {
          this.alertRef.current.sendAlert("Purchase order couldn't be finished.");
        }
        this.setState({ submitting: false });
      });
  };

  handleTransportCondition = (event) => {
    this.setState({ transportCondition: event.target.value });
  };

  handleTransportTemperature = (event) => {
    const transportTemperature = event.target.value ? Number(event.target.value) : event.target.value;
    const errorTemperature = !transportTemperature;
    this.setState({ transportTemperature: transportTemperature, errorTemperature: errorTemperature });
  };

  onPrint = () => {
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    var content = document.getElementById(`poPrint${this.props.match.params.id}`);
    pri.document.write(content.innerHTML);
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    }, 50);
  };

  handleInvoiceEdit = () => {
    this.setState({ isInvoiceUpdating: true });
  };

  handleInvoiceEditChange = (event) => {
    //check if invoice is not empty
    this.setState({ newInvoice: event.target.value, invoiceError: !event.target.value });
  };

  handleInvoiceEditSubmit = () => {
    const newInvoice = this.state.newInvoice;
    if (newInvoice && !this.state.invoiceError) {
      changePurchaseOrderInvoiceNumber(this.props.match.params.id, {
        invoice_number: newInvoice,
      }).then(
        (response) => {
          this.alertRef.current.sendAlert(`Puchase Order Invoice ID has been updated!`, "success");
          this.setState({ isInvoiceUpdating: false });
        },
        () => {
          this.alertRef.current.sendAlert("Puchase Order Invoice ID couldn't be updated");
        }
      );
    } else this.setState({ invoiceError: true });
  };

  handleInvoiceEditCancel = () => {
    this.setState({ newInvoice: undefined, invoiceError: false, isInvoiceUpdating: false });
  };

  handleAmountEdit = () => {
    this.setState({ isAmountUpdating: true });
  };

  handleAmountEditChange = (event) => {
    //check if amount is an positive value
    if (event.target.value <= 0) this.setState({ newAmount: event.target.value, amountError: true });
    else this.setState({ newAmount: event.target.value, amountError: false });
  };

  handleAmountEditSubmit = () => {
    const newAmount = this.state.newAmount;
    if (newAmount && !this.state.amountError) {
      changePurchaseOrderInvoiceAmount(this.props.match.params.id, {
        invoice_amount: Number(newAmount),
      }).then(
        (response) => {
          this.alertRef.current.sendAlert(`Puchase Order Invoice Amount has been updated!`, "success");
          this.setState({ isAmountUpdating: false });
        },
        () => {
          this.alertRef.current.sendAlert("Puchase Order Invoice Amount couldn't be updated");
        }
      );
    } else this.setState({ amountError: true });
  };

  handleAmountEditCancel = () => {
    this.setState({ newAmount: undefined, amountError: false, isAmountUpdating: false });
  };

  // Create labels
  handleCreateLabels = (item, scan) => {
    this.setState({ creatingLabelsForItem: item, scanLabels: scan });
  };

  handleBack = () => {
    this.setState({ creatingLabelsForItem: undefined, labelError: undefined, successMessage: undefined });
  };

  handleChangeMode = (item) => {
    this.setState({ creatingLabelsForItem: item, scanLabels: !this.state.scanLabels });
  };

  handleOnAdd = (item_id, barcode, plant, price, weight, packingDate, vendorLotNumber, repeat) => {
    createPurchaseOrderItemLabel(item_id, barcode, plant, price, weight, packingDate, vendorLotNumber, repeat).then(
      (response) => {
        this.setState({ successMessage: undefined });
        this.props.createPurchaseOrderItemLabelSuccess(response.data);
        this.setState({ labelError: undefined, successMessage: "Label successfuly added" });
      },
      (error) => this.setState({ labelError: error.response.data })
    );
  };

  handleOnDelete = (itemId, label_id) => {
    deletePurchaseOrderItemLabel(itemId, label_id).then(
      (response) => {
        this.setState({ successMessage: undefined });
        this.props.deletePurchaseOrderItemLabelSuccess(response.data);
        this.setState({ labelError: undefined, successMessage: "Label successfuly deleted" });
      },
      (error) => this.setState({ labelError: error.response.data })
    );
  };

  confirmSubmit = () => {
    this.finishPurchaseOrder(false);
    this.setState({ openAmountMismatchModal: false });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    const { purchaseOrder, loading, error } = this.props.purchaseOrder;

    if (!purchaseOrder && !loading && error) {
      return <Navigate to="/purchase_orders" />;
    }

    if (!purchaseOrder) {
      return (
        <div>
          <Alert ref={this.alertRef} />
          <Spinner />
        </div>
      );
    }

    if (purchaseOrder.status === 0 || purchaseOrder.status === 2) {
      return <Navigate to={`/purchase_orders/${this.props.match.params.id}`} />;
    }

    const styleFrame = {
      height: "0px",
      width: "0px",
      position: "absolute",
    };

    if (this.state.creatingLabelsForItem) {
      return (
        <div>
          <PurchaseOrderCreateLabelHeader
            purchaseOrder={purchaseOrder}
            purchaseOrderItem={this.state.creatingLabelsForItem}
            handleBack={this.handleBack}
            handleChangeMode={this.handleChangeMode}
          />
          <PurchaseOrderCreateLabelAdd
            scan={this.state.scanLabels}
            item={this.state.creatingLabelsForItem}
            handleOnAdd={this.handleOnAdd}
            labelError={this.state.labelError}
            successMessage={this.state.successMessage}
          />
          <PurchaseOrderCreateLabelListAdded item={this.state.creatingLabelsForItem} handleOnDelete={this.handleOnDelete} />
        </div>
      );
    }


    return (
      <div className="animated fadeIn">
        <Alert ref={this.alertRef} />
        {purchaseOrder.invoice && (
          <Modal
            closeModal={() => this.setState({ openAmountMismatchModal: false })}
            isModalOpen={this.state.openAmountMismatchModal}
            onConfirm={this.debounceConfirmSubmit}
            onCancel={() => this.setState({ openAmountMismatchModal: false })}
            header="Amount mismatch"
            onConfirmButtonText="Yes"
            onCancelButtonText="No"
            children={
              <div>
                {Object.keys(this.state.finishErrors).map((key) => (
                  <li>{this.state.finishErrors[key]}</li>
                ))}
                <br />
                <span>Are you sure you want to proceed?</span>
              </div>
            }
          />
        )}
        {purchaseOrder.invoice && (
          <PurchaseOrderDetailHeader
            purchaseOrderInvoice={purchaseOrder.invoice.invoice_number}
            purchaseOrderInvoiceAmount={purchaseOrder.invoice.total_amount}
            purchaseOrderVendor={purchaseOrder.vendor.name}
            status={purchaseOrderStatusOptions[purchaseOrder.status]}
            handleFinishPurchaseOrder={this.debounceHandleFinishPurchaseOrder}
            handlePrint={this.onPrint}
            transportCondition={this.state.transportCondition}
            handleTransportCondition={this.handleTransportCondition}
            purchaseOrderTransportConditions={purchaseOrderTransportConditions}
            transportTemperature={this.state.transportTemperature}
            handleTransportTemperature={this.handleTransportTemperature}
            errorTemperature={this.state.errorTemperature}
            submitting={this.state.submitting}
            hasInvoice
            newInvoice={this.state.newInvoice}
            invoiceError={this.state.invoiceError}
            isInvoiceUpdating={this.state.isInvoiceUpdating}
            handleInvoiceEdit={this.handleInvoiceEdit}
            handleInvoiceEditChange={this.handleInvoiceEditChange}
            handleInvoiceEditSubmit={this.handleInvoiceEditSubmit}
            handleInvoiceEditCancel={this.handleInvoiceEditCancel}
            newAmount={this.state.newAmount}
            amountError={this.state.amountError}
            isAmountUpdating={this.state.isAmountUpdating}
            handleAmountEdit={this.handleAmountEdit}
            handleAmountEditChange={this.handleAmountEditChange}
            handleAmountEditSubmit={this.handleAmountEditSubmit}
            handleAmountEditCancel={this.handleAmountEditCancel}
          />
        )}
        {!purchaseOrder.invoice && (
          <PurchaseOrderDetailHeader
            status={purchaseOrderStatusOptions[purchaseOrder.status]}
            handleFinishPurchaseOrder={this.debounceHandleFinishPurchaseOrder}
            handleAssociateInvoice={this.handleAssociateInvoice}
            handleInvoiceInput={this.handleInvoiceInput}
            handlePrint={this.onPrint}
            invoice={this.state.invoice}
            error={this.state.error}
            transportCondition={this.state.transportCondition}
            handleTransportCondition={this.handleTransportCondition}
            purchaseOrderTransportConditions={purchaseOrderTransportConditions}
            transportTemperature={this.state.transportTemperature}
            handleTransportTemperature={this.handleTransportTemperature}
            errorTemperature={this.state.errorTemperature}
            submitting={this.state.submitting}
            isAssociateInvoice
          />
        )}
        <PurchaseOrderDetail
          isFromInvoice
          purchaseOrder={purchaseOrder}
          handleTemperatureSubmit={this.handleTemperatureSubmit}
          handleCreateLabels={this.handleCreateLabels}
        />
        <PurchaseOrderPrint
          poId={purchaseOrder.id}
          vendor={purchaseOrder.vendor.name}
          createdBy={purchaseOrder.created_by}
          date={purchaseOrder.date}
          items={purchaseOrder.items}
          status={purchaseOrder.status}
        />
        {loading ? <Spinner /> : null}
        {/* Print */}
        <iframe id="ifmcontentstoprint" style={styleFrame}></iframe>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    purchaseOrder: state.purchaseOrders.purchaseOrderDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPurchaseOrderDetail: (id) => {
      dispatch(fetchPurchaseOrderDetail(id)).payload.then(
        (response) => {
          dispatch(fetchPurchaseOrderDetailSuccess(response.data));
        },
        (error) => {
          dispatch(fetchPurchaseOrderDetailFailure(error));
        }
      );
    },
    createPurchaseOrderItemLabelSuccess: (data) => {
      dispatch(createPurchaseOrderItemLabelSuccess(data));
    },
    deletePurchaseOrderItemLabelSuccess: (data) => {
      dispatch(deletePurchaseOrderItemLabelSuccess(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderInvoiceDetailContainer));
